<template>
  <SummaryReportsTable />
</template>

<script>
import SummaryReportsTable from "@/v3components/Datatables/SummaryReportsTable"
export default {
  name: "SummaryReports",
  components: { SummaryReportsTable }
}
</script>
